import { ApplicationCard } from '@sec-loans-ui/common/steps/loan-catalog-step/components/ApplicationCard'
import { ApplicationDetails } from '@sec-loans-ui/common/steps/loan-catalog-step/types'
import { ApplicationSelectData } from '@sec-loans-ui/common/types'
import { TightSectionContent } from '@ui-components/containers/TightSectionContent'
import { BREAKPOINT_DESKTOP_PX } from '@ui-components/global/constants'
import { TertiaryHeading } from '@ui-components/typography/headings/TertiaryHeading'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

const ApplicationsWrapper = styled(TightSectionContent)`
  @media (min-width: ${BREAKPOINT_DESKTOP_PX}px) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(424px, 1fr));
  }
`

export const ExistingApplicationsView = ({
  userSsn,
  inProgressApplications,
  completedApplications,
  onApplicationSelect,
}: {
  userSsn: string
  inProgressApplications: ApplicationDetails[]
  completedApplications: ApplicationDetails[]
  onApplicationSelect: (input: ApplicationSelectData) => void
}) => {
  const { formatMessage } = useIntl()

  return (
    <TightSectionContent>
      <ApplicationSection
        userSsn={userSsn}
        applications={inProgressApplications}
        header={formatMessage({ id: 'application-list-in-progress-applications' })}
        additionalText={formatMessage({ id: 'application-list-in-progress-applications-deletion-info' })}
        onApplicationSelect={onApplicationSelect}
      />
      <ApplicationSection
        userSsn={userSsn}
        applications={completedApplications}
        header={formatMessage({ id: 'application-list-completed-applications' })}
        additionalText={formatMessage({ id: 'application-list-completed-applications-deletion-info' })}
        onApplicationSelect={onApplicationSelect}
      />
    </TightSectionContent>
  )
}

const ApplicationSection = ({
  userSsn,
  header,
  additionalText,
  applications,
  onApplicationSelect,
}: {
  userSsn: string
  header: string
  additionalText: string
  applications: ApplicationDetails[]
  onApplicationSelect: (input: ApplicationSelectData) => void
}) => {
  return applications.length > 0 ? (
    <>
      <TertiaryHeading header={header} additionalText={additionalText} tagName={'h2'} />
      <ApplicationsWrapper>
        {applications.map((applicationDetails) => (
          <ApplicationCard
            key={applicationDetails.applicationMetadata.applicationId}
            userSsn={userSsn}
            applicationDetails={applicationDetails}
            onApplicationSelect={onApplicationSelect}
          />
        ))}
      </ApplicationsWrapper>
    </>
  ) : null
}
